export default "__VITE_ASSET__DCESDgc7__"